import { createStyles, makeStyles, Theme } from '@material-ui/core';

const useStyles = makeStyles((theme: Theme) =>
  createStyles({
    customWidth: {
      maxWidth: 400,
    },
    content: {
      display: 'flex',
      alignItems: 'center',
      textAlign: 'center',
    },
    title: {
      background: theme.palette.secondary.contrastText,
      textAlign: 'center',
    },
  }),
);
export default useStyles;
